// extracted by mini-css-extract-plugin
export default {"backHeader":"LiveCalendar_backHeader--Pv0","emptyStateText":"LiveCalendar_emptyStateText--rgw"};